export const readFile = (file: File, callback: (content: string) => void) => {
  const reader = new FileReader();

  if (!file.name.endsWith('.ngpd')) {
    throw new Error(
      'Could not import flowsheet. It is only possible to import flowsheets of type .ngpd',
    );
  }

  reader.onabort = () => {
    throw new Error('File import aborted');
  };

  reader.onerror = () => {
    throw new Error('File import failed');
  };

  reader.onload = () => {
    if (!reader.result) {
      throw new Error('Failed to read file');
    }

    const fileContent = reader.result.toString();

    callback(fileContent);
  };

  reader.readAsText(file);
};
